import { useMemo } from 'react'
import Link from 'next/link'
import { NextImage } from '@/components/NextImage'
import { useTranslation } from '@/localization/useTranslation'
import { IPlaylistScript } from '@/types'
import { IPlaylistResponse } from '@/types/playlist'
import { TopNavigation } from '../Navigation/TopNavigation'

import classNames from 'classnames'
import classes from './styles.module.scss'

interface HeaderProps {
  options: IPlaylistScript['options']
  data: IPlaylistResponse
  totalItems: number
  isPlaceholder: boolean
  swiperInstance?: any
  isFetching?: boolean
  fetchNextPage?: () => Promise<any>
  hasNextPage?: boolean
}

export const Header = (props: HeaderProps) => {
  const {
    options,
    data,
    totalItems,
    isPlaceholder,
    swiperInstance,
    isFetching = false,
    fetchNextPage,
    hasNextPage = false,
  } = props
  const { t } = useTranslation()
  const { title, _id: id } = data
  const { text: seeMoreText, active: isSeeMoreActive = true, link: seeMoreLink } = options?.seeMore || {}
  const { icon, hideTitle, customTitle } = options || {}
  const shouldShowSeeMore = useMemo(() => !isPlaceholder && isSeeMoreActive !== false, [isPlaceholder, isSeeMoreActive])
  const seeMoreUrl = useMemo(() => seeMoreLink || `/see-more?id=${id}`, [seeMoreLink, id])

  if (hideTitle) return null

  return (
    <div className={classes.header}>
      <h2 className={classNames({
        [classes.title]: true,
        [classes.title__placeholder]: isPlaceholder
      })}>
        {icon &&
          <span className={classes.title__logo}>
            <NextImage
              src={icon}
              alt={t(title)}
              width={32}
              height={32}
            />
          </span>
        }
        {t(customTitle || title)}
      </h2>
      <div className={classes.header__right}>
        {shouldShowSeeMore && (
          <Link href={seeMoreUrl} className={classes['see-more']}>
            {t(seeMoreText || 'See more')}
          </Link>
        )}
        {swiperInstance && (
          <TopNavigation
            swiper={swiperInstance}
            hasNextPage={hasNextPage}
            fetchNextPage={fetchNextPage}
            totalItems={totalItems}
            isFetching={isFetching}
            isPlaceholder={isPlaceholder}
          />
        )}
      </div>
    </div>
  )
}